import { motion } from "framer-motion";
import { Activity, Clock, Compass, TrendingDown, ListChecks, Building2 } from "lucide-react";
import SceneShell from "../components/SceneShell";

/**
 * Scene 37 — Right now, social channels are dying.
 * Six pain points laid out as a problem grid.
 */

const pains = [
  { icon: Activity, label: "Inconsistent posting" },
  { icon: Clock, label: "No time" },
  { icon: Compass, label: "No strategy" },
  { icon: TrendingDown, label: "No real return" },
  { icon: ListChecks, label: "Agent Dependent" },
  { icon: Building2, label: "Centralised · not local" },
];

export default function Scene37_ChannelsDying() {
  return (
    <SceneShell variant="forest" align="left" data-testid="scene-channels-dying">
      <motion.div
        className="absolute inset-0 pointer-events-none"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2 }}
        style={{
          background:
            "radial-gradient(ellipse at 25% 50%, rgba(139,26,46,0.32) 0%, transparent 55%)",
        }}
      />

      <div className="relative max-w-[1500px] mx-auto w-full">
        <motion.h2
          initial={{ opacity: 0, y: 24, filter: "blur(8px)" }}
          animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          transition={{ duration: 1.0, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
          className="kn-display text-5xl sm:text-7xl lg:text-[110px] text-white leading-[0.95]"
          data-testid="dying-title"
        >
          Social channels
          <br />
          are{" "}
          <span style={{ color: "#e9a820" }}>dying.</span>
        </motion.h2>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-5xl">
          {pains.map((p, i) => {
            const Icon = p.icon;
            return (
              <motion.div
                key={p.label}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                  delay: 0.7 + i * 0.13,
                  duration: 0.7,
                  ease: [0.16, 1, 0.3, 1],
                }}
                className="flex items-center gap-4 rounded-xl p-5"
                style={{
                  background: "rgba(200,58,79,0.06)",
                  border: "1px solid rgba(200,58,79,0.22)",
                }}
                data-testid={`dying-pain-${i}`}
              >
                <Icon
                  className="w-6 h-6 shrink-0"
                  style={{ color: "#c83a4f" }}
                />
                <span
                  className="text-base sm:text-lg"
                  style={{ color: "rgba(255,255,255,0.85)" }}
                >
                  {p.label}
                </span>
              </motion.div>
            );
          })}
        </div>
      </div>
    </SceneShell>
  );
}
